import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import poster from './modules/poster'
import video from './modules/video'
import article from './modules/article'
import member from './modules/member'
import publicModules from './modules/public'
import role from './modules/role'
import cps from './modules/cps'
import question from './modules/question'
import supplier from './modules/supplier'
import product from './modules/product'
import proposal from './modules/proposal'
import refund from './modules/refund'
import serviceCharge from './modules/serviceCharge'
import commission from './modules/commission'
import CpsApiPosterAPI from './modules/CpsApiPoster'
import insurancePolicy from './modules/insurancePolicy'
import renewal from './modules/renewal'
import platformGuide from './modules/platformGuide'
import policyButler from './modules/policy-butler'
import common from './modules/common'
import passwordStatus from './modules/passwordStatus'
import website from "./modules/website"
import startClass from './modules/startClass'
import startClassApplet from './modules/startClassApplet'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app,
        poster,
        video,
        article,
        member,
        role,
        publicModules,
        cps,
        question,
        supplier,
        product,
        proposal,
        refund,
        serviceCharge,
        commission,
        CpsApiPosterAPI,
        insurancePolicy,
        renewal,
        platformGuide,
        policyButler,
        common,
        passwordStatus,
        website,
        startClass,
        startClassApplet
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js